import { odata } from '../../conf';

export default {
  async LOAD_unitsOfMeasure({ commit, rootGetters }) {
    const data = await odata.o(rootGetters)
      .get('unitsOfMeasure')
      .query({ $filter: 'IsDeleted eq false' });
    commit('SET_unitsOfMeasure', data);
  },
  async loadUnitsOfMeasure({ commit, rootGetters }) {
    const data = await odata.o(rootGetters)
      .get('unitsOfMeasure')
      .query({ $filter: 'IsDeleted eq false' });
    commit('SET_unitsOfMeasure', data);
  },
  async createUnitOfMeasure({ commit, rootGetters, state }, unitOfMeasure) {
    const data = await odata.o(rootGetters)
      .post('unitsOfMeasure', unitOfMeasure)
      .query();
    const { unitsOfMeasure } = state;
    unitsOfMeasure.push(data);
    commit('SET_unitsOfMeasure', unitsOfMeasure);
  },
  async updateUnitOfMeasure({ dispatch, rootGetters }, unitOfMeasure) {
    await odata.o(rootGetters)
      .patch(`unitsOfMeasure/${unitOfMeasure.id}`, unitOfMeasure)
      .query();
    dispatch('loadUnitsOfMeasure');
  },
};
